import { Extend, Extends, isDev, isProd } from '../index';

const Ext: Extend = {};

Ext[isProd] = {};
Ext[isDev] = {};

Extends.OMUA = Ext;

export {};
